import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { FormErrors } from "./FormErrors";
import "./styles.css";
import { changePassword } from "../../actions/user";

class FormPasswordChange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      passwordMatch: "",
      password: "",
      newPassword: "",
      newPasswordConfirm: "",
      formErrors: { password: "" },
      passwordValid: false,
      formValid: false,
      type: "password",
      submitDisabled: false
    };
    this.showHide = this.showHide.bind(this);
  }

  handleUserInput = e => {
    const name = e.target.name;
    const value = e.target.value;
    const newState = {
      ...this.state,
      [name]: value
    };
    this.setState(newState);
  };

  onBlur = e => {
    const name = e.target.name;
    const value = e.target.value;
    this.validateField(name, value);
  };

  onSubmit = e => {
    e.preventDefault();
    let { password } = this.state;
    const newPassword = this.state.newPassword.trim();
    const newPasswordConfirm = this.state.newPasswordConfirm.trim();
    if (newPassword.length > 3) {
      if (newPassword === newPasswordConfirm) {
        this.props
          .changePassword({
            password,
            newPassword
          })
          .then(response => {
            if (response.success) {
              this.setState({
                successMessage: "Паролата е сменена успешно!",
                submitDisabled: true,
                password: "",
                newPassword: "",
                newPasswordConfirm: "",
                passwordMatch: "",
                formValid: true,
                formErrors: {},
                passwordValid: true
              });
            }
          });
      } else {
        this.setState({
          passwordMatch: "Паролите не съвпадат"
        });
      }
    }
  };

  validateField(fieldName, value) {
    const passwordValid = value.trim().length > 5;
    let formErrors = {};

    formErrors[fieldName] = !passwordValid ? " е твърде кратка" : "";

    this.setState({
      formErrors,
      passwordValid,
      formValid: passwordValid
    });
  }

  errorClass(error) {
    return error.length === 0 ? "" : "has-error";
  }

  showHide(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      type: this.state.type === "password" ? "input" : "password"
    });
  }

  render() {
    const {
      password,
      newPassword,
      newPasswordConfirm,
      submitDisabled
    } = this.state;

    const disabled =
      submitDisabled ||
      !password.trim().length ||
      !newPassword.trim().length ||
      !newPasswordConfirm.trim().length;

    return (
      <div className="form-password-change">
        <form onSubmit={this.onSubmit}>
          <div className="form-row form-row-pass">
            <input
              onBlur={this.onBlur}
              type={this.state.type}
              className="input"
              name="password"
              placeholder="Парола"
              value={this.state.password}
              onChange={this.handleUserInput}
            />
            <div className="eye" onClick={this.showHide}>
              <span
                className={
                  this.state.type === "password"
                    ? "icon-eye-off"
                    : "icon-eye-on"
                }
              />
            </div>
          </div>

          <div className="form-row form-row-pass">
            <input
              onBlur={this.onBlur}
              type={this.state.type}
              className="input"
              name="newPassword"
              placeholder="Нова парола"
              value={this.state.newPassword}
              onChange={this.handleUserInput}
            />
            <div className="eye" onClick={this.showHide}>
              <span
                className={
                  this.state.type === "password"
                    ? "icon-eye-off"
                    : "icon-eye-on"
                }
              />
            </div>
          </div>

          <div className="form-row form-row-pass">
            <input
              onBlur={this.onBlur}
              type={this.state.type}
              className="input"
              name="newPasswordConfirm"
              value={this.state.newPasswordConfirm}
              placeholder="Потвърди нова парола"
              onChange={this.handleUserInput}
            />
            <div className="eye" onClick={this.showHide}>
              <span
                className={
                  this.state.type === "password"
                    ? "icon-eye-off"
                    : "icon-eye-on"
                }
              />
            </div>
          </div>

          <div className="form-row-bttn">
            <FormErrors
              formErrors={this.state.formErrors}
              className="formErrors"
            />
            {this.state.passwordMatch && (
              <span className="formErrors">{this.state.passwordMatch}</span>
            )}
            {this.state.successMessage && (
              <span style={{ color: "green" }}>
                {this.state.successMessage}
              </span>
            )}
            <button type="submit" className="bttn" disabled={disabled}>
              Смени парола
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  changePassword: payload => dispatch(changePassword(payload))
});

export default connect(
  null,
  mapDispatchToProps
)(FormPasswordChange);



// WEBPACK FOOTER //
// ./src/components/FormPasswordChange/FormPasswordChange.js